// v2.19.28 — OnboardingAddressModal : invitation post-login à créer son adresse AYA.
// S'affiche après vérif OTP réussi si l'utilisateur n'a pas encore d'adresse revendiquée
// et n'a pas marqué le prompt comme "dismissed".
import { useCallback, useState } from "react";
import "./OnboardingAddressModal.css";

const NOTCH_URL = "/aya/notch.png";
const API = process.env.REACT_APP_BACKEND_URL || "";

async function postStatus(action, token) {
  if (!token) return;
  try {
    await fetch(`${API}/api/auth/me/address-prompt-status`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ action }),
    });
  } catch (_) { /* silencieux */ }
}

export default function OnboardingAddressModal({ open, token, seenCount = 0, onClose }) {
  const [busy, setBusy] = useState(false);

  const handleCreateNow = useCallback(async () => {
    setBusy(true);
    await postStatus("seen", token);
    sessionStorage.setItem("aya_from_onboarding", "1");
    window.location.href = "/mon-compte?onboarding=1#addresses";
  }, [token]);

  const handleLater = useCallback(async () => {
    setBusy(true);
    await postStatus("later", token);
    onClose && onClose();
    setBusy(false);
  }, [token, onClose]);

  const handleDismiss = useCallback(async () => {
    setBusy(true);
    await postStatus("dismissed", token);
    onClose && onClose();
    setBusy(false);
  }, [token, onClose]);

  if (!open) return null;

  // Légère pression à la 2e occurrence.
  const headerLine = seenCount >= 1
    ? "On reprend ? Ton adresse t'attend toujours."
    : "Bienvenue dans AYA AI";

  return (
    <div className="onb-overlay" data-testid="onboarding-address-overlay">
      <div className="onb-modal" data-testid="onboarding-address-modal" role="dialog" aria-modal="true">
        <button type="button" className="onb-close" onClick={handleLater} disabled={busy} aria-label="Fermer" data-testid="onboarding-close-btn">✕</button>
        <img src="/aya/pin-art.jpg" alt="" className="onb-art" />
        <div className="onb-hero">
          <img src={NOTCH_URL} alt="" className="onb-mask" />
        </div>
        <div className="onb-eyebrow">{headerLine}</div>
        <h2 className="onb-title">✨ Crée ton adresse <span className="onb-aya">AYA</span></h2>
        <p className="onb-lead">
          Ton adresse AYA permet à tes proches, livreurs et services postaux de te trouver
          <strong> exactement chez toi</strong> — partout en Côte d’Ivoire.
        </p>
        <ul className="onb-list">
          <li><span className="onb-tile">🚚</span><span><span className="onb-li-title">Yango, Glovo, livreurs</span><br /><span className="onb-li-sub">Ils viennent directement à ta porte</span></span></li>
          <li><span className="onb-tile">📦</span><span><span className="onb-li-title">Colis et lettres</span><br /><span className="onb-li-sub">Finis les “à côté du grand fromager”</span></span></li>
          <li><span className="onb-tile">🏛️</span><span><span className="onb-li-title">Banques, administrations</span><br /><span className="onb-li-sub">Preuve d’adresse instantanée</span></span></li>
        </ul>
        <div className="onb-timer">⏱️ Crée ton adresse en 30 secondes.</div>
        <div className="onb-actions">
          <button
            type="button"
            className="onb-btn onb-btn-primary"
            onClick={handleCreateNow}
            disabled={busy}
            data-testid="onboarding-create-now-btn"
          >✨ Créer mon adresse maintenant →</button>
          <button
            type="button"
            className="onb-btn onb-btn-secondary"
            onClick={handleLater}
            disabled={busy}
            data-testid="onboarding-later-btn"
          >⏰ Plus tard</button>
        </div>
        <button
          type="button"
          className="onb-dismiss-link"
          onClick={handleDismiss}
          disabled={busy}
          data-testid="onboarding-dismiss-btn"
        >Non merci, ne plus afficher</button>
      </div>
    </div>
  );
}
